export default {
  title: "light",
  colors: {
    primary: "#848482 ",
    secundary: "#B0B1AE",
    background: "#F4F5F2",
    text: "#333",
  },
};
